import React, { useEffect, useState } from 'react';
import { Col, Form, InputGroup, Row } from 'react-bootstrap';
import { Recording } from 'types/rest/assetCatalogTypes';
import { useDispatch } from 'react-redux';
import { MockService } from 'types/rest/mockServiceTypes';
import { updateRunTimeConfigThunk } from 'store/mockServices/mockServiceDetail/mockServiceDetailActions';
import _ from 'lodash';
import { showToastNotification } from 'store/ui/toasts/toastsActions';
import { ToastType } from 'store/ui/toasts/toastsTypes';
import { isTemplate } from '../../../../../../../utils/miscUtil';
import { updateTemplateRunTimeConfigThunk } from '../../../../../../../store/mockServiceTemplates/mockServiceTemplateDetail/mockServiceTemplateDetailActions';
import { useIsMount } from '../../../../../../../hooks/useIsMountHook';

interface Props {
  recording: Recording;
  mockService: MockService;
}

const AssignedRecordingDetail = ({ recording, mockService }: Props) => {
  const dispatch = useDispatch();

  const [runtimeConfig, setRuntimeConfig] = useState(recording.runtimeConfig);
  const isMount = useIsMount();

  useEffect(() => {
    if (!isMount && runtimeConfig !== recording.runtimeConfig) {
      updateRecordingRunTimeConfig();
    }
  }, [runtimeConfig]);

  /**
   * Updates the runtime configuration of the recording.
   * Uses debounce to limit the rate of updates.
   */
  const updateRecordingRunTimeConfig = _.debounce(() => {
    try {
      if (isTemplate(mockService)) {
        dispatch(updateTemplateRunTimeConfigThunk(mockService, recording.id, runtimeConfig));
      } else {
        dispatch(updateRunTimeConfigThunk(mockService, recording.id, runtimeConfig));
      }
    } catch (e) {
      console.error('Error updating runtime config', e);
      dispatch(showToastNotification(ToastType.Danger, 'Error updating runtime config'));
    }
  }, 500);

  const updateRunTimeConfigHandler = (field: string, value: any) => {
    const config = { ...runtimeConfig, [field]: Number(value) };
    setRuntimeConfig(config);
  };

  return (
    <div className={'px-5 pt-5'}>
      <Row>
        <Col md={6}>
          <Form.Group className={'mb-3'}>
            <Form.Label>Delay Between Replays</Form.Label>
            <InputGroup>
              <Form.Control
                min={0}
                type="number"
                placeholder="Enter delay between replays..."
                value={runtimeConfig?.delayBetweenReplays}
                onChange={e => updateRunTimeConfigHandler('delayBetweenReplays', e.target.value)}
              />
              <InputGroup.Append>
                <InputGroup.Text>ms</InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Form.Group>

          <Form.Group className={'mb-3'}>
            <Form.Label>Initial Delay</Form.Label>
            <InputGroup>
              <Form.Control
                min={0}
                type="number"
                placeholder="Enter initial delay..."
                value={runtimeConfig?.initialDelay}
                onChange={e => updateRunTimeConfigHandler('initialDelay', e.target.value)}
              />
              <InputGroup.Append>
                <InputGroup.Text>ms</InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className={'mb-3'}>
            <Form.Label>Replay Count</Form.Label>
            <Form.Control
              min={0}
              type="number"
              placeholder="Enter replay count..."
              value={runtimeConfig?.replayCount}
              onChange={e => updateRunTimeConfigHandler('replayCount', e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default AssignedRecordingDetail;
